export default __webpack_public_path__ + "static/media/bl7.2aa23471.png";